;(function () {

"use strict";

var PageView = Backbone.View.extend({
  initialize: function () {
    console.log('install charge view init');
  },
  events: {
    'submit form': function(e) {
      e.preventDefault();
      e.stopPropagation();

      ShopifyApp.Bar.loadingOn();
      $.post('/charge', undefined, function (data) {
        ShopifyApp.Bar.loadingOff();
        if (data.status === 'success') {
          ShopifyApp.redirect(data.url.split('/admin').pop());
          // window.location.href = data.url;
        } else {
          ShopifyApp.Modal.alert({
            title: 'Applying Charge Failed',
            message: data.err
          });
        }
      });
    }
  }
});

module.exports = PageView;

}());